import { trigger, transition, style, animate } from '@angular/animations';
import { LoadingService } from './../services/loading.service';
import { Component, OnInit } from '@angular/core';
import { Fade } from '../animation';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css'],
    animations: [
        trigger('inOuta', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.3s ease-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('0.3s ease-in', style({ opacity: 0 })),
            ]),
        ]),
        Fade,
    ],
    standalone: false
})
export class LoadingComponent {
  color = 'red';

  constructor(public loadingService: LoadingService) {}
}
